/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const isFocusable = (element?: HTMLElement): boolean => {
  if (!element) return false;
  if (element.hasAttribute("disabled")) return false;

  return (
    element.tabIndex >= 0 ||
    element.isContentEditable ||
    (element instanceof HTMLAnchorElement && !!element.href) ||
    element instanceof HTMLButtonElement ||
    element instanceof HTMLInputElement ||
    element instanceof HTMLSelectElement ||
    element instanceof HTMLTextAreaElement
  );
};
